import { getAppConfig } from "services/configService";
import { checkResponse, DELETE, GET, parseJson, POST, PUT, rawGET } from "services/httpService";
import urlJoin from "url-join";

const apiUrl = () => {
  return getAppConfig().WidgetApiUrl;
};

/*
There are 2 ways of referring to orders.
1 = SuperOrder -> Order -> OrderLines
OR
2 = Order -> Product -> CopyItem
We are converting the result form the API (1) to (2)
Maybe it was a mistake and we should have selected (1) naming :)
*/
const mapWidget = widget => {
  return {
    ...widget,
    productCode: widget.orderCode,
    orderCode: undefined
  };
};

export const getWidgetByCode = async (requestInfo, productCode) => {
  return await rawGET(requestInfo, urlJoin(apiUrl(), `/v1/widget/${productCode}`))
    .then(async res => {
      if (res.status === 401) return null;
      return await checkResponse(res);
    })
    .then(parseJson)
    .then(widget => mapWidget(widget || {}));
};

export const deleteWidgetByCode = async (requestInfo, productCode) => {
  return await DELETE(requestInfo, urlJoin(apiUrl(), `/v1/widget/${productCode}`));
};

export const putWidgetShareEmail = async (
  requestInfo,
  productCode,
  vendorId,
  fromName,
  toEmailAddress,
  personalMessage
) => {
  return await PUT(
    requestInfo,
    urlJoin(
      apiUrl(),
      `/v1/widget/${productCode}/share?vendorId=${vendorId}&fromName=${fromName}&personalMessage=${personalMessage}&toEmailAddress=${toEmailAddress}`
    )
  );
};

export const postRequestWidgetCreation = (requestInfo, productCode) => {
  return POST(requestInfo, urlJoin(apiUrl(), `/v1/widget/${productCode}`));
};

export const getWidgets = async (requestInfo, productCodes) => {
  const widgets = await GET(requestInfo, urlJoin(apiUrl(), `/v1/widget/all?orderCodes=${productCodes.toString()}`));
  return widgets.map(w => mapWidget(w));
};
